module.exports = __webpack_public_path__ + "img/droplet_gray.cb702f29.svg";